"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getVideoFrame = void 0;

var getVideoFrame = function getVideoFrame(container, video) {
  var cf = {
    x: 0,
    y: 0,
    w: container.offsetWidth,
    h: container.offsetHeight
  };
  var w = cf.w;
  var h = cf.h;
  var x = 0;
  var y = 0;

  if (video && video.videoWidth) {
    w = cf.w;
    h = w * (video.videoHeight / video.videoWidth);

    if (h > cf.h) {
      h = cf.h;
      w = h * (video.videoWidth / video.videoHeight);
    }

    x = (cf.w - w) / 2;
    y = (cf.h - h) / 2;
  }

  var videoFrame = {
    x: x,
    y: y,
    w: w,
    h: h
  };
  console.log('Video frame', videoFrame);
  return videoFrame;
};

exports.getVideoFrame = getVideoFrame;